export enum ReviewEntriesFilterType {
  Supplier = 'supplier',
  Account = 'account',
  ExclVat = 'exclVat',
  VatRate = 'vatRate',
  InclVat = 'inclVat',
}
